import { useEffect, useState } from "react";

import { WebinarVideoForm } from "./WebinarVideoForm";
import { format } from "date-fns";

export const WebinarsPlayer = ({ data }) => {
  const [flagPresent, setFlagPresent] = useState();

  useEffect(() => {
    setFlagPresent(localStorage.getItem("video_form_filled"));
  }, []);

  /* eslint-disable jsx-a11y/media-has-caption */
  return (
    <>
      {flagPresent ? (
        <video className="webinar_player" src={data?.video_actual} controls>
          Sorry, your browser doesn't support HTML5 <code>video</code>, but you can download this
          video from the{" "}
          <a href={data?.video_actual} target="_blank" rel="noreferrer">
            {data?.title}
          </a>
          .
        </video>
      ) : (
        <WebinarVideoForm setFlagPresent={setFlagPresent} />
      )}
      <h1 className="webinar_player-title">{data?.title}</h1>
      <p className="webinar_player-date">
        {data?.date && format(new Date(data?.date), "LLLL dd, yyyy")}
      </p>
    </>
  );
};
